export const DEFAULTS = {
    API: {
        PAGE_SIZE: 10,
    },
    DATE_FORMAT: 'ddd, D. MMM YYYY',
    API_REQUEST_DATE_FORMAT: 'YYYY-MM-DD',
};
